import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** Affiche un QR code (image PNG data-URL) à partir d'une chaîne. 100% hors-ligne. */
export function Qr({ data, size = 160, className }: { data: string; size?: number; className?: string }) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    let ok = true;
    QRCode.toDataURL(data, { margin: 1, width: size, errorCorrectionLevel: 'M' })
      .then((u) => ok && setUrl(u))
      .catch(() => ok && setUrl(''));
    return () => { ok = false; };
  }, [data, size]);
  if (!url) return null;
  return (
    <img
      src={url}
      width={size}
      height={size}
      alt="QR"
      className={className}
      style={{ display: 'block', margin: '0 auto', imageRendering: 'pixelated' }}
    />
  );
}

/** Préfixe des QR de ticket TAJ FUSION. */
export const TICKET_PREFIX = 'TAJ:';

/** Préfixe des QR de carte fidélité (envoyée par email au membre). */
export const LOYALTY_PREFIX = 'TAJFID:';

/** Extrait le code fidélité d'un QR scanné (TAJFID:TAJ1234 → TAJ1234). Null si ce n'est pas une carte. */
export function parseLoyaltyQr(text: string): string | null {
  const s = (text ?? '').trim();
  if (!s.toUpperCase().startsWith(LOYALTY_PREFIX)) return null;
  return s.slice(LOYALTY_PREFIX.length).trim().toUpperCase() || null;
}

/** Encode l'ID d'une commande dans le QR du ticket. */
export const ticketQrData = (orderId: string) => TICKET_PREFIX + orderId;

/** Extrait l'ID de commande d'un texte scanné (accepte avec ou sans préfixe TAJ:). */
export function parseTicketQr(text: string): string | null {
  const s = (text ?? '').trim();
  if (!s) return null;
  if (s.startsWith(TICKET_PREFIX)) return s.slice(TICKET_PREFIX.length).trim() || null;
  // QR = URL de suivi .../suivi/<id> → on extrait l'id
  const suivi = s.match(/\/suivi\/([^/?#\s]+)/i);
  if (suivi) return suivi[1];
  // tolérance : URL finissant par l'id brut (cuid) ou id seul
  const m = s.match(/([a-z0-9]{20,})\s*$/i);
  return m ? m[1] : s;
}

// ─── QR de connexion (Admin / Responsable / Caissier) ───
export const LOGIN_PREFIX = 'TAJLOGIN:';
export const loginQrData = (token: string) => LOGIN_PREFIX + token;
export function parseLoginQr(text: string): string | null {
  const s = (text ?? '').trim();
  if (!s.toUpperCase().startsWith(LOGIN_PREFIX)) return null;
  return s.slice(LOGIN_PREFIX.length).trim() || null;
}
